/* Fishical Pursuit — nav resilience patch (v2)
 * Fixes:
 *  1) iOS Safari: the "Menu" button on custom pages doesn't open the nav drawer.
 * Approach: pure client-side patch; runs on every page, idempotent, no DOM assumption failures.
 * NOTE: v1 also injected a wordmark logo into the nav; that was removed at merchant's request.
 * The real .hero-logo anchor is fixed in CSS instead (pointer-events).
 */
(function(){
  'use strict';

  function ready(fn){
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, {once:true});
  }

  ready(function(){
    document.querySelectorAll('nav.fp-nav').forEach(function(nav){
      var btn = nav.querySelector('#hamburgerBtn, .hamburger, .nav-toggle');
      var links = nav.querySelector('#navLinks, .nav-links');
      if (btn && links && !btn.dataset.fpBound){
        btn.dataset.fpBound = '1';
        var toggle = function(e){
          if (e) { e.preventDefault(); e.stopPropagation(); }
          var isOpen = links.classList.toggle('open');
          btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          document.body.classList.toggle('fp-nav-open', isOpen);
        };
        btn.addEventListener('click', toggle, false);
        btn.addEventListener('touchend', toggle, {passive:false});
        // Close menu after tapping any nav link
        links.querySelectorAll('a').forEach(function(a){
          a.addEventListener('click', function(){
            links.classList.remove('open');
            btn.setAttribute('aria-expanded','false');
            document.body.classList.remove('fp-nav-open');
          });
        });
        // Close on outside tap
        document.addEventListener('click', function(e){
          if (!links.classList.contains('open')) return;
          if (nav.contains(e.target)) return;
          links.classList.remove('open');
          btn.setAttribute('aria-expanded','false');
          document.body.classList.remove('fp-nav-open');
        });
      }
    });
  });
})();
